import { useEffect, useState } from 'react';
import { values, DIL, Result, SrsParameters, SRSValuesResult } from 'srs-middleware';

/**
 * Hook to fetch from values endpoint
 */
export function useFetchValues(selectedDefinition: DIL,
    result: Result,
    properties: string[],
    parameters: SrsParameters
  ) {
  const [isLoading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState<any[]>(null);

  useEffect(() => {
    async function fetchValues() {
      setLoading(true);
      if (!parameters)
        return;

      try {        
        let response: SRSValuesResult<any>[] = await values(result, selectedDefinition.propertyList, parameters);
        setData(response.map(x => {return {documentId: x.documentId, externalId: x.externalId, ...x.propertyValues}}));
        setLoading(false)
      } catch (e) {
        setLoading(false);
        setError(e);
        setData(null);

        // TODO: handle exceptions correctly
        console.error(e);
      }
    }

    if (result) {
      fetchValues();
    }
  }, [result, selectedDefinition, properties, parameters]);

  return {data, loading: isLoading, error};
}
